import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

const prefersDark = () =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia('(prefers-color-scheme: dark)').matches;

/** Resolve the stored preference ('system' included) into 'light' | 'dark'. */
export const resolveMode = (preference) =>
  preference === 'system' ? (prefersDark() ? 'dark' : 'light') : preference;

const useThemeStore = create(
  persist(
    (set, get) => ({
      // 'dark' | 'light' | 'system'
      preference: 'system',

      setPreference: (preference) => set({ preference }),

      // Cycles dark → light → system, which is what the sidebar toggle does.
      cyclePreference: () => {
        const order = ['dark', 'light', 'system'];
        const next = order[(order.indexOf(get().preference) + 1) % order.length];
        set({ preference: next });
        return next;
      },

      getMode: () => resolveMode(get().preference)
    }),
    {
      name: 'roadmap-theme',
      storage: createJSONStorage(() => localStorage)
    }
  )
);

export default useThemeStore;
